import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { errMsg } from "./ui";

export default function InlineEditCell({ value, display, onCommit, min = 0, minExclusive = false, invalidMsg, testId, title, className = "" }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const done = useRef(false);

  const start = () => { done.current = false; setVal(String(value ?? 0)); setEditing(true); };
  const save = async () => {
    if (done.current) return;
    done.current = true;
    const n = Number(val);
    const bad = val.trim() === "" || !Number.isFinite(n) || (minExclusive ? n <= min : n < min);
    if (bad) { toast.error(invalidMsg); setEditing(false); return; }
    if (n === value) { setEditing(false); return; }
    setBusy(true);
    try { await onCommit(n); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false); setEditing(false);
  };
  const onKey = (e) => {
    if (e.key === "Enter") { e.preventDefault(); save(); }
    if (e.key === "Escape") { done.current = true; setEditing(false); }
  };

  if (editing) return (
    <input data-testid={`${testId}-input`} autoFocus type="number" min={min} step="any" value={val} disabled={busy}
      onChange={(e) => setVal(e.target.value)} onKeyDown={onKey} onBlur={save} onFocus={(e) => e.target.select()}
      className="w-28 bg-[#191A1F] border border-[#D4AF37] text-[#F5F3ED] text-right rounded-sm px-2 py-1 outline-none" />
  );
  return (
    <button type="button" data-testid={testId} onClick={start} title={title}
      className={`group inline-flex items-center gap-1.5 rounded-sm px-2 py-1 -mr-2 border border-transparent hover:border-[#D4AF37]/60 transition-colors ${className}`}>
      <span>{display ?? value}</span>
      <Pencil size={11} className="opacity-30 group-hover:opacity-100 text-[#D4AF37] transition-opacity" />
    </button>
  );
}
